import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SemanticsService {
  isBusy?: boolean;
  language = 'gr';

  constructor(private http: HttpClient) {
  }

  setGreekLanguage() {
    this.language = 'gr';
  }

  setEnglishLanguage() {
    this.language = 'en';
  }


  public async sendTextForAnalysis(text: string, onSuccess: any = null, onError: any = null) {
    const body = {
      text,
      language: this.language
    };
    this.isBusy = true;
    return this.http.post(environment.semanticsApi, body)
      .subscribe((data: any) => {
        console.log(data);
        if (data.status === 0) {
          console.log('Upload text and language successfully');
          if (onSuccess) {
            onSuccess(data.data);
          }
        } else {
          if (onError) {
            onError();
          }
          console.log(data.message);
        }
        this.isBusy = false;
      }, err => {
        console.log(err);
        this.isBusy = false;
        if (onError) {
          onError();
        }
      });
  }
}
